import React, { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NotificationBell from '../components/NotificationBell';
import LiveDot from '../components/LiveDot';
import AccountSwitcher from '../components/AccountSwitcher';
import Icon from '../components/Icons';
import VerificationBanner from '../components/VerificationBanner';
import Overview from '../views/trader/Overview';
import OpenTrades from '../views/trader/OpenTrades';
import TradeHistory from '../views/trader/TradeHistory';
import Followers from '../views/trader/Followers';
import Performance from '../views/trader/Performance';
import Settings from '../views/shared/Settings';
import Accounts from '../views/shared/Accounts';

const NAV = [
  { to: '/trader',             end: true, icon: 'overview', label: 'Overview' },
  { to: '/trader/trades',      icon: 'trades',   label: 'Open Trades' },
  { to: '/trader/history',     icon: 'history',  label: 'Trade History' },
  { to: '/trader/followers',   icon: 'users',    label: 'My Followers' },
  { to: '/trader/performance', icon: 'trophy',   label: 'Performance' },
  { to: '/trader/settings',    icon: 'user',     label: 'Settings' },
];

export default function TraderLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className={`wrapper ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <div className="sidebar" data-color="black">
        <div className="sidebar-wrapper">
          <div className="logo">
            <span className="simple-text">CopyTrade</span>
            <div className="logo-sub" style={{
              fontSize: 11, color: 'var(--text-tertiary)',
              textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 4,
            }}>Trader</div>
            <button
              className="sidebar-close"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
            >
              <Icon name="close" size={20} />
            </button>
          </div>
          <ul className="nav">
            {NAV.map(item => (
              <li key={item.to}>
                <NavLink to={item.to} end={item.end}>
                  <Icon name={item.icon} size={18} className="nav-icon" />
                  <p>{item.label}</p>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-absolute navbar-transparent">
          <div className="container-fluid">
            <button
              className="navbar-toggle"
              onClick={() => setSidebarOpen(v => !v)}
              aria-label="Open menu"
            >
              <Icon name="menu" size={22} />
            </button>
            <div className="navbar-wrapper">
              <div className="navbar-brand">
                <span className="navbar-brand-full">CopyTrade — Trader</span>
                <span className="navbar-brand-short">Trader</span>
              </div>
            </div>
            <div className="navbar-nav ml-auto">
              <AccountSwitcher />
              <LiveDot />
              <NotificationBell />
              <span className="nav-link text-white user-email">
                <Icon name="user" size={14} className="mr-1" />
                <span className="d-none d-md-inline">{user?.username || user?.email}</span>
              </span>
              <button
                className="btn btn-sm btn-outline-secondary ml-2 logout-btn"
                onClick={handleLogout}
                aria-label="Logout"
              >
                <Icon name="logout" size={14} />
                <span className="d-none d-sm-inline ml-1">Logout</span>
              </button>
            </div>
          </div>
        </nav>

        <div className="content">
          <VerificationBanner user={user} />
          <Routes>
            <Route path="/"            element={<Overview />} />
            <Route path="/trades"      element={<OpenTrades />} />
            <Route path="/history"     element={<TradeHistory />} />
            <Route path="/followers"   element={<Followers />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/accounts"    element={<Accounts />} />
            <Route path="/settings"    element={<Settings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
